module.exports = __webpack_public_path__ + "static/media/UBQ.565ed25a.svg";